/* Winning PDP kit (27 Oct 2026): the page script, loaded deferred by sections/wp-main.
   The colour switch itself lives in the inline boot of sections/wp-main (window.wpPdp), so a tap works before this file.
   Here: gallery arrows + thumbnails, the sticky bar, the buy call (one tap = one bag, then the
   store's path), testimonial dots, "more reviews", the look-alikes fetch. No dependency on the theme's scripts. */
(function () {
  'use strict';
  var W = window.wpPdp = window.wpPdp || {};
  if (W.page) return;
  W.page = true;
  var doc = document, root = doc.documentElement;
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function raf(fn) { var q = false; return function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; fn(); }); }; }
  var cfg = (W.data && W.data()) || {};

  /* ---------- re-sync after an early tap (elements parsed after the tap) ---------- */
  if (W.apply && W.byId) W.apply(W.byId(W.cur), { silent: true, keepGallery: !W.tapAt });
  if (window.wpDates) window.wpDates();

  /* ---------- gallery ---------- */
  var main = $('[data-wp-main]');
  var track = main && $('[data-wp-track]', main), thumbs = main && $('[data-wp-thumbs]', main);
  var prev = main && $('[data-wp-prev]', main), next = main && $('[data-wp-next]', main);
  function slides() { return track ? Array.prototype.filter.call(track.children, function (s) { return !s.hidden; }) : []; }
  function index() { var w = track.clientWidth || 1; return Math.round(track.scrollLeft / w); }
  function go(i, smooth) {
    var n = slides().length; i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function mark() {
    if (!track) return;
    var ss = slides(), i = Math.min(index(), ss.length - 1), id = ss[i] && ss[i].getAttribute('data-m');
    if (thumbs) $$('.wp-gal__thumb', thumbs).forEach(function (t) {
      var on = t.getAttribute('data-m') === id;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on && thumbs.scrollWidth > thumbs.clientWidth) {
        var l = t.offsetLeft - thumbs.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbs.scrollLeft || r > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: l - 8, behavior: 'smooth' });
      }
    });
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= ss.length - 1;
  }
  if (track) {
    W.galChanged = function () { mark(); };
    track.addEventListener('scroll', raf(mark), { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.wp-gal__thumb'); if (!t) return;
      var ss = slides(), id = t.getAttribute('data-m');
      for (var i = 0; i < ss.length; i++) if (ss[i].getAttribute('data-m') === id) { go(i); break; }
    });
    window.addEventListener('resize', raf(function () { go(index(), false); mark(); }));
    mark();
  }

  /* ---------- full-screen viewer: lives in the inline boot (sections/wp-main), so a photo tap works before this file ---------- */
  var viewer = $('[data-wp-viewer]');

  /* ---------- sticky bar: on whenever the page's own button is not fully in view, never over the price lines ---------- */
  var bar = $('[data-wp-sticky]'), mainBtn = $('[data-wp-main-btn]'), priceBox = $('[data-wp-pricebox]');
  var btnFull = true;
  function syncSticky() {
    if (!bar) return;
    var dr = doc.querySelector('cart-drawer');
    var on = !btnFull && (!viewer || viewer.hidden) && !(dr && dr.classList.contains('active'));
    if (on && priceBox) {
      var r = priceBox.getBoundingClientRect(), h = bar.offsetHeight || 64;
      if (r.bottom > window.innerHeight - h && r.top < window.innerHeight) on = false;
    }
    if (bar.classList.contains('is-on') === on) return;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if ('inert' in bar) bar.inert = !on;
    doc.body.classList.toggle('wp-sticky-on', on);
  }
  W.syncSticky = syncSticky;
  /* a long colour name (Coffee Brown) drops the "· 7 colours" count instead of ending in an ellipsis */
  var sName = bar && bar.querySelector('.wp-sticky__name');
  function fitSticky() {
    if (!sName) return;
    sName.classList.remove('is-tight');
    if (sName.scrollWidth > sName.clientWidth + 1) sName.classList.add('is-tight');
  }
  fitSticky();
  doc.addEventListener('wp:variant', fitSticky);
  window.addEventListener('resize', raf(fitSticky));
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitSticky);
  if (bar && mainBtn) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { btnFull = en.isIntersecting && en.intersectionRatio > 0.98; }); syncSticky(); },
        { threshold: [0, 0.5, 0.99, 1] }).observe(mainBtn);
    } else {
      var chk = function () { var r = mainBtn.getBoundingClientRect(); btnFull = r.top >= 0 && r.bottom <= window.innerHeight; syncSticky(); };
      window.addEventListener('scroll', raf(chk), { passive: true }); chk();
    }
    window.addEventListener('scroll', raf(syncSticky), { passive: true });
    var drw = doc.querySelector('cart-drawer');
    if (drw && 'MutationObserver' in window) new MutationObserver(function () { syncSticky(); }).observe(drw, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', raf(syncSticky));
    if ('inert' in bar) bar.inert = true;
  }

  /* ---------- buy: one tap = one bag, then the store's path ---------- */
  var busy = false, holdT = 0;
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function setBusy(on) {
    busy = on;
    $$('[data-wp-buy]').forEach(function (b) { b.classList.toggle('is-busy', on); if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
    clearTimeout(holdT);
    if (on) holdT = setTimeout(function () { setBusy(false); }, 12000);
  }
  function showErr(msg) { $$('[data-wp-err]').forEach(function (p) { p.textContent = msg || ''; }); }
  function buy(form) {
    if (busy || !form) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    setBusy(true); showErr('');
    try { if (cfg.clarity && typeof window.clarity === 'function') window.clarity('event', cfg.clarity); } catch (e) {}
    var path = form.getAttribute('data-wp-form') || cfg.path || 'checkout';
    var drawer = doc.querySelector('cart-drawer');
    if (path === 'drawer' && drawer && drawer.renderContents && drawer.getSectionsToRender) {
      // the theme's own drawer, the way its product form does it: add + the drawer's sections in one call
      var fd = new FormData();
      fd.append('id', id.value); fd.append('quantity', '1');
      fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      fetch(routes + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          setTimeout(function () { if (!drawer.classList.contains('active') && drawer.open) drawer.open(); syncSticky(); }, 60);
          setBusy(false);
        })
        .catch(function (err) { setBusy(false); showErr((err && (err.description || err.message)) || ''); });
      return;
    }
    fetch(routes + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw res.j;
        if (path === 'checkout') { window.location.href = '/checkout'; return; }
        if (path === 'drawer' && W.openDrawer) { W.openDrawer(res.j); setBusy(false); return; }
        window.location.href = routes + 'cart';
      })
      .catch(function (err) { setBusy(false); showErr((err && (err.description || err.message)) || ''); });
  }
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-wp-form]')) return;
    e.preventDefault();
    buy(f);
  }, true);
  // a tap on the sticky bar's text ("Schwarz · 3 Farben") brings her to the colours
  doc.addEventListener('click', function (e) {
    var m = e.target && e.target.closest ? e.target.closest('[data-wp-sticky-meta]') : null;
    if (!m) return;
    var o = $('.wp-opts'); if (!o) return;
    window.scrollTo({ top: Math.max(0, o.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3), behavior: 'smooth' });
  });
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wp-sticky-btn]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    buy($('form[data-wp-form]'));
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });

  /* ---------- testimonials: one card at a time, dots ---------- */
  $$('[data-wp-carousel]').forEach(function (c) {
    var tr = $('[data-wp-carousel-track]', c), dots = $$('[data-wp-carousel-dots] button', c);
    if (!tr || !dots.length) return;
    function cur() { var card = tr.children[0]; var w = card ? card.getBoundingClientRect().width + 12 : tr.clientWidth; return Math.round(tr.scrollLeft / (w || 1)); }
    tr.addEventListener('scroll', raf(function () { var i = cur(); dots.forEach(function (d, j) { d.setAttribute('aria-current', i === j ? 'true' : 'false'); }); }), { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { var card = tr.children[j]; if (card) tr.scrollTo({ left: card.offsetLeft - tr.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft || 0), behavior: 'smooth' }); }); });
  });

  /* ---------- reviews: 6 per load ---------- */
  $$('[data-wp-rv-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.parentElement.querySelector('[data-wp-rv-list]'); if (!list) return;
      var hid = $$('.wp-rv__item[hidden]', list);
      hid.slice(0, 6).forEach(function (x) { x.hidden = false; });
      if (hid.length <= 6) btn.hidden = true;
    });
  });

  /* ---------- look-alikes: loaded when she gets near the end ---------- */
  $$('[data-wp-la]').forEach(function (box) {
    var url = box.getAttribute('data-url'); if (!url || box.children.length) return;
    var load = function () {
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var got = tmp.querySelector('[data-wp-la]');
        if (got && got.innerHTML.trim()) box.innerHTML = got.innerHTML;
      }).catch(function () {});
    };
    // the empty box has no height, so an IntersectionObserver never reports it: check the distance on scroll instead,
    // and load anyway once the page has been idle for a while
    var done = false;
    var near = function () {
      if (done) return;
      var top = box.getBoundingClientRect().top;
      if (top < window.innerHeight + 1200) { done = true; window.removeEventListener('scroll', onScroll); load(); }
    };
    var onScroll = raf(near);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', function () { setTimeout(function () { if (!done) { done = true; load(); } }, 4000); });
    near();
  });
})();
